class BlogLoadMore extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('[data-blog-load-more] button');
    this.articlesContainer = document.querySelector('[data-blog-articles-container]');
    
    if (this.button && this.articlesContainer) {
      this.button.addEventListener('click', this.handleLoadMore.bind(this));
    }
  }

  async handleLoadMore(event) {
    const button = event.currentTarget;
    const currentPage = parseInt(button.dataset.currentPage) || 1;
    const totalPages = parseInt(button.dataset.totalPages) || 1;
    const blogUrl = button.dataset.blogUrl;
    const sectionId = button.dataset.sectionId;
    const nextPage = currentPage + 1;

    // Check if there are more pages
    if (nextPage > totalPages) {
      return;
    }

    // Show loading state
    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');
    const textSpan = button.querySelector('.blog-load-more__text');
    const spinnerSpan = button.querySelector('.blog-load-more__spinner');
    if (textSpan) textSpan.classList.add('hidden');
    if (spinnerSpan) spinnerSpan.classList.remove('hidden');

    try {
      // Fetch the next page using Shopify's section rendering API
      const url = `${blogUrl}?section_id=${sectionId}&page=${nextPage}`;
      const response = await fetch(url);
      const html = await response.text();
      
      // Parse the response
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newSection = doc.querySelector(`[data-blog-articles-container]`);
      const newLoadMoreContainer = doc.querySelector('[data-blog-load-more]');

      if (newSection) {
        // Get all article elements from the new page
        const newArticles = newSection.querySelectorAll('.blog-articles__article');
        
        // Calculate the next animation order
        const existingArticles = this.articlesContainer.querySelectorAll('.blog-articles__article');
        let nextAnimationOrder = existingArticles.length + 1;

        // Append each new article to the container
        newArticles.forEach((article) => {
          // Update animation order if animations are enabled
          const cascadeElement = article.querySelector('[data-cascade]');
          if (cascadeElement) {
            cascadeElement.style.setProperty('--animation-order', nextAnimationOrder);
          }
          
          // Clone and append the article
          const clonedArticle = article.cloneNode(true);
          this.articlesContainer.appendChild(clonedArticle);
          nextAnimationOrder++;
        });

        // Update button state based on new pagination data
        if (newLoadMoreContainer) {
          const newButton = newLoadMoreContainer.querySelector('button');
          if (newButton) {
            const newCurrentPage = parseInt(newButton.dataset.currentPage) || nextPage;
            const newTotalPages = parseInt(newButton.dataset.totalPages) || totalPages;
            
            button.dataset.currentPage = newCurrentPage;
            button.dataset.totalPages = newTotalPages;
            
            // Hide button if no more pages
            if (newCurrentPage >= newTotalPages) {
              button.closest('[data-blog-load-more]').classList.add('hidden');
            }
          } else {
            // No button means no more pages, hide the load more container
            button.closest('[data-blog-load-more]').classList.add('hidden');
          }
        } else {
          // No load more container means no more pages, hide the button
          button.closest('[data-blog-load-more]').classList.add('hidden');
        }

        // Reinitialize scroll animations if available
        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(this.articlesContainer.innerHTML);
        }
      }
    } catch (error) {
      console.error('Error loading more articles:', error);
      // Show error message or restore button state
    } finally {
      // Remove loading state
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
      if (textSpan) textSpan.classList.remove('hidden');
      if (spinnerSpan) spinnerSpan.classList.add('hidden');
    }
  }
}

customElements.define('blog-load-more', BlogLoadMore);
